"use strict";
Object.defineProperty(exports, "__esModule", { value: true });
var home_src_1 = require("./home.src");
exports.home = home_src_1.home;



//////////////////
// WEBPACK FOOTER
// C:/WS/ls/build/player-career-site/src/.tmp/home/home.controls.tsx
// module id = 304
// module chunks = 0